import React from 'react';

//dropdown BARRIOS => solo barrios de la zona seleccionada
const DetDetalleSelBa = props => {
  return (
    <option dato1={props.elemento.codigoTipoDocT?props.elemento.codigoTipoDocT:""}
    dato2={props.elemento.numeroDocumT?props.elemento.numeroDocumT:""}
    dato3={props.elemento.descrRecursoT?props.elemento.descrRecursoT:""}
    dato4={props.elemento.codigoTipoDocR?props.elemento.codigoTipoDocR:""}
    dato5={props.elemento.numeroDocumR?props.elemento.numeroDocumR:""}
    dato6={props.elemento.descrRecursoR?props.elemento.descrRecursoR:""}
    dato7={props.elemento.codigoZona} dato8={props.elemento.nombreZona}
    value={props.elemento.codigoBarrio}>{props.elemento.nombreBarrio}</option>
  )
};

const ListaBa = ({styles, handleLista3, list}) => {
// const Lista = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetDetalleSelBa styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3" onChange={handleLista3}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown BARRIOS

export default ListaBa